function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.3 49.4L3.7 3H69.6L35.3 49.4ZM23.1 13.3L35.6 31.7L49.2 13.3H23.1Z",
  fill: "#00B3E7"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M59.7 54.9H13.7V65.2H59.7V54.9Z",
  fill: "#00B3E7"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M109.3 54.9V38.2H93.3V54.9H83.7V13.4H93.3V29.6H109.3V13.4H118.9V54.9H109.3Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M130.8 54.9V13.4H157.1V22.2H140.4V29.6H155.6V38.1H140.4V46.2H157.1V55L130.8 54.9Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M168.4 54.9V13.4H178V46.2H194.7V55L168.4 54.9Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M203.1 54.9V13.4H212.7V46.2H229.4V55L203.1 54.9Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M256.1 55.6C243.2 55.6 235 46.4 235 34.2C235 22 243.6 12.7 256.5 12.7C269.4 12.7 277.6 21.9 277.6 34.2C278 45.6 269.2 55.2 257.8 55.7C257.2 55.6 256.6 55.6 256.1 55.6ZM256.2 21.3C249.6 21.3 245.2 26.7 245.2 34.2C245.2 41.7 249.6 47.1 256.2 47.1C262.8 47.1 267.2 41.7 267.2 34.2C267.2 26.7 262.8 21.3 256.2 21.3Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M298.3 55.6C293.3 55.4 288.5 54 284.3 51.3L287 42.6C290.4 45.1 294.4 46.5 298.6 46.6C302 46.6 303.3 45 303.3 43C303.3 41 302.2 39.4 295.9 36.8C288.6 33.9 286 29.6 286 24.6C286 18.5 290.9 12.6 300.6 12.6C304.7 12.6 308.7 13.7 312.2 15.8L309.7 24.4C307 22.5 303.8 21.3 300.5 21C297 21 295.6 22.7 295.6 24.4C295.6 27.1 297.7 28 302.9 30.2C310.7 33.5 313 37.2 313 42.6C313.1 49.3 308.3 55.6 298.3 55.6Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M323 54.9V13.4H332.6V54.9H323Z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M379.8 31.5V51.3C375 54.1 369.6 55.6 364 55.5C351.8 55.5 342.2 46.8 342.2 34.1C342.2 21.4 351.9 12.6 364.5 12.6C369.4 12.6 374.2 13.8 378.4 16.2L374.4 24C371.5 22.5 368.3 21.7 365.1 21.7C356.8 21.7 352.4 26.9 352.4 34.2C352.4 42.1 357.7 47.1 364.5 47.1C366.6 47.3 368.7 46.9 370.6 46V39.8H362.3V31.7L379.8 31.5Z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M425.1 55.7L400 33.2V54.9H390.4V12.8L391.7 12.6L416.4 34.9V13.4H426V55.7H425.1Z"
});

const SvgHelloSign = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 430 68",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgHelloSign, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hello-sign.e602b9ca.svg";
export { ForwardRef as ReactComponent };